module.exports = __webpack_public_path__ + "img/works_xikemu_dx_6.25fedca1.jpg";